import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.pictureBlob)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $setup.pictureBlob,
          class: "profile-avatar"
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true)
  ]))
}